<template>
    <div>
        <b-form class="step-form" @submit.stop.prevent="onSubmit">
            <div class="row">
                <div class="col-lg-12">
                    <h3>Upload Documents</h3>
                </div>
                <div class="col-lg-12">
                    <div class="row form-options">
                        <!-- <div class="col-lg-12">
                            <p class="upload-doc-rc-p">
                                *Please Note: Document Source of Income should
                                not be older than 60 days
                            </p>
                        </div> -->
                        <div class="col-lg-6">
                            <div class="info-error">
                                <i
                                    v-b-tooltip.hover
                                    class="icon-error_outline"
                                    title="Document Source of Income should not be older than 60 days"
                                ></i>
                            </div>

                            <utility-bill :field="fieldSourceOfIncome">
                            </utility-bill>
                        </div>
                        <template v-if="addNominee == 'Yes'">
                            <div class="col-lg-6">
                                <utility-bill
                                    :field="fieldNomineeCNIC"
                                ></utility-bill>
                            </div>
                            <div class="col-lg-6">
                                <utility-bill
                                    :field="fieldNomineeCNICBack"
                                ></utility-bill>
                            </div>
                        </template>
                        <!-- <div class="col-lg-6">
                            <utility-bill :field="fieldW9Form"></utility-bill>
                        </div> -->

                        <!-- <div class="col-lg-6">
                            <utility-bill :field="fieldW8Form"></utility-bill>
                        </div> -->
                        <!-- <div class="col-lg-6">
                            <utility-bill
                                :field="fieldBusinessProof"
                            ></utility-bill>
                        </div> -->
                        <!-- <div class="col-lg-6">
                        <utility-bill
                            :field="fieldCRS"
                        ></utility-bill>
                    </div> -->
                        <div class="col-lg-6">
                            <utility-bill
                                :field="fieldDigitalSignature"
                            ></utility-bill>
                        </div>
                        <div v-if="fieldZakatAffidavit.show" class="col-lg-6">
                            <utility-bill
                                :field="fieldZakatAffidavit"
                            ></utility-bill>
                        </div>
                        <!-- <div class="col-lg-6" v-if="fieldUtility.show">
                            <utility-bill :field="fieldUtility"></utility-bill>
                        </div> -->
                        <div
                            :class="{
                                'col-lg-6': showName == 'r-visible',
                            }"
                        >
                            <utility-bill
                                v-if="showName == 'r-visible'"
                                :field="fieldPmdaRelative"
                            ></utility-bill>
                        </div>
                        <div
                            :class="{
                                'col-lg-6': showName == 'c-visible',
                            }"
                        >
                            <utility-bill
                                v-if="showName == 'c-visible'"
                                :field="fieldPmdaCompany"
                            ></utility-bill>
                        </div>
                        <!-- <div class="col-lg-6">
                        <signature ref="signature"></signature>
                    </div> -->
                    </div>
                </div>
                <div class="col-lg-4">
                    <b-button
                        size="sm"
                        variant="secondary"
                        class="mr-3"
                        @click="onBack"
                    >
                        Back
                    </b-button>
                    <base-button
                        btn-type="submit"
                        btn-variant="primary"
                        btn-label="CONTINUE"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                    ></base-button>
                </div>
            </div>

            <b-modal
                ref="pmda"
                size="md"
                title="Warning"
                hide-footer
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
            >
                <pmda-modal @selection="acceptPmda"></pmda-modal>
            </b-modal>
        </b-form>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'

import { registrationRequiresW9 } from '@/utils/registrationTaxForms'

import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocument from '@/components/registration/IdentityDocument.vue'
import UtilityBill from '@/components/registration/UtilityBill.vue'
import Cropper from '@/components/registration/Cropper.vue'
import PmdaModal from '@/components/registration/PmdaModal'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        IdentityType,
        IdentityDocument,
        UtilityBill,
        Cropper,
        PmdaModal,
        // VueCroppie,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            otpData: null,
            is_data_fetched: false,
            showName: 'n-visible',

            fieldUtility: {
                isRequired: true,
                isDisable: false,
                isLocked: true,
                show: true,
                key: 'documentInfo.utility.fileName',
                originalFileNameKey: 'documentInfo.utility.originalFileName',
                keyBackEnd: 'utility',
                label: 'UTILITY BILL SCAN COPY',
                urduLabel: 'یوٹیلیٹی بل اسکین کاپی',
                vvName: 'utility bill scan copy',
                // hyperLink:
                //     process.env.VUE_APP_API_URL + 'files/docs/utility-bill.pdf',
                // hyperLinkLabel: 'Download sample',
            },
            fieldPmdaRelative: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                show: false,
                key: 'documentInfo.pmdaRelativeForm.fileName',
                originalFileNameKey:
                    'documentInfo.pmdaRelativeForm.originalFileName',
                keyBackEnd: 'pmdaRelativeForm',
                label: 'PMDA RELATIVE FORM SCAN COPY',
                urduLabel: 'PMDA رشتہ دار فارم اسکین کاپی',
                vvName: 'Pmda relative form scan copy',
                // hyperLink:
                //     process.env.VUE_APP_API_URL +
                //     'files/docs/ltr-Family-converted.pdf',
                // hyperLinkLabel: 'Download sample',
            },
            fieldPmdaCompany: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                show: false,
                key: 'documentInfo.pmdaCompanyForm.fileName',
                originalFileNameKey:
                    'documentInfo.pmdaCompanyForm.originalFileName',
                keyBackEnd: 'pmdaCompanyForm',
                label: 'PMDA COMPANY FORM SCAN COPY',
                urduLabel: 'PMDA کمپنی کے فارم کی اسکین کاپی',
                vvName: 'Pmda company form scan copy',
            },
            // fieldCRS: {
            //     isRequired: true,
            //     isLocked: true,
            //     key: 'documentInfo.crsForm.fileName',
            //     originalFileNameKey: 'documentInfo.crsForm.originalFileName',
            //     keyBackEnd: 'crsForm',
            //     label: 'CRS Form SCAN COPY',
            //     vvName: 'CRS Form scan copy',
            //     hyperLink:
            //         'https://www.alfalahghp.com/storage/downloads/K1e4GZMMeZC7zm3Y.pdf',
            //     hyperLinkLabel: 'Download sample',
            // },

            fieldSourceOfIncome: {
                isRequired: true,
                isLocked: true,
                key: 'documentInfo.sourceOfIncome.fileName',
                originalFileNameKey:
                    'documentInfo.sourceOfIncome.originalFileName',
                keyBackEnd: 'sourceOfIncome',
                label: 'Document source of income SCAN COPY',
                urduLabel: 'آمدنی کا دستاویزی ذریعہ اسکین کاپی',
                vvName: 'Document source of income scan copy',
            },

            fieldNomineeCNIC: {
                isRequired: true,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.nomineeCNIC.fileName',
                originalFileNameKey:
                    'documentInfo.nomineeCNIC.originalFileName',
                keyBackEnd: 'nomineeCNIC',
                label: 'Nominee CNIC FRONT SCAN COPY',
                urduLabel: 'نامزد کردہ CNIC اسکین کاپی',
                vvName: 'Nominee CNIC front scan copy',
            },
            fieldNomineeCNICBack: {
                isRequired: true,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.nomineeCNICBack.fileName',
                originalFileNameKey:
                    'documentInfo.nomineeCNICBack.originalFileName',
                keyBackEnd: 'nomineeCNICBack',
                label: 'Nominee CNIC BACK SCAN COPY',
                urduLabel: 'نامزد کردہ CNIC BACK اسکین کاپی',
                vvName: 'Nominee CNIC BACK scan copy',
            },

            fieldW9Form: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.w9Form.fileName',
                originalFileNameKey: 'documentInfo.w9Form.originalFileName',
                keyBackEnd: 'w9Form',
                label: 'W-9 form (US Citizen) SCAN COPY',
                urduLabel: 'W-9 فارم (امریکی شہری) اسکین کاپی',
                vvName: 'W-9 form (US Citizen) scan copy',
            },

            fieldZakatAffidavit: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                show: false,
                key: 'documentInfo.zakatAffidavit.fileName',
                originalFileNameKey:
                    'documentInfo.zakatAffidavit.originalFileName',
                keyBackEnd: 'zakatAffidavit',
                label: 'Zakat Affidavit SCAN COPY',
                urduLabel: 'زکوٰۃ کے حلف نامے کی اسکین کاپی',
                vvName: 'Zakat Affidavit scan copy',
            },

            fieldW8Form: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.w8Form.fileName',
                originalFileNameKey: 'documentInfo.w8Form.originalFileName',
                keyBackEnd: 'w8Form',
                label: 'W-8 form (for Non-US citizen) SCAN COPY',
                vvName: 'W-8 form (for Non-US citizen) scan copy',
                urduLabel: 'W-8 فارم (غیر امریکی شہری کے لیے) اسکین کاپی',
            },

            fieldBusinessProof: {
                isRequired: true,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.businessProof.fileName',
                originalFileNameKey:
                    'documentInfo.businessProof.originalFileName',
                keyBackEnd: 'businessProof',
                label: 'Business/Employment Proof SCAN COPY',
                vvName: 'Business/Employment Proof scan copy',
                urduLabel: 'کاروبار/ملازمت کے ثبوت کی اسکین کاپی',
            },

            // fieldFatcaForm: {
            //     isRequired: true,
            //     isLocked: true,
            //     key: 'documentInfo.fatcaForm.fileName',
            //     originalFileNameKey: 'documentInfo.fatcaForm.originalFileName',
            //     keyBackEnd: 'fatcaForm',
            //     label: 'FATCA Form SCAN COPY',
            //     vvName: 'FATCA Form Proof scan copy',
            //     hyperLink:
            //         'https://www.alfalahghp.com/storage/downloads/K1e4GZMMeZC7zm3Y.pdf',
            //     hyperLinkLabel: 'Download sample',
            // },

            fieldCNICBack: {
                isRequired: true,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.cnicBack.fileName',
                originalFileNameKey: 'documentInfo.cnicBack.originalFileName',
                keyBackEnd: 'cnicBack',
                label: 'Id Document BACK SCAN COPY',
                vvName: 'Id Document BACK scan copy',
                urduLabel: 'شناختی دستاویز کی بیک اسکین کاپی',
            },

            fieldDigitalSignature: {
                isRequired: true,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.digitalSignature.fileName',
                originalFileNameKey:
                    'documentInfo.digitalSignature.originalFileName',
                keyBackEnd: 'digitalSignature',
                label: 'DIGITAL SIGNATURE SCAN COPY',
                urduLabel: 'ڈیجیٹل دستخط کی اسکین کاپی',
                vvName: 'Digital signature scan copy',
            },
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
            addNominee: (state) =>
                state.registration.form.accountInfo.addNominee,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        async 'form.documentInfo.identity.fileName'(value) {
            // check if the value is not empty
            // and perform action accordintly
            if (this.userOcr && value !== null && value !== undefined) {
                try {
                    const formData = new FormData()
                    formData.append(
                        'filePath',
                        `${process.env.VUE_APP_API_URL}files/customers/${value}`
                    )
                    formData.append('type', 'id')

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post('ocr/', formData, {
                        headers,
                    })

                    if (
                        ['upload-document', 'record-video'].includes(
                            this.$route.name.toString()
                        )
                    ) {
                        this.$store.commit('updateField', {
                            key: 'identityInfo.number',
                            value: data.customer_data.idnumber,
                        })

                        this.$store.commit('updateField', {
                            key: 'identityInfo.expiryDate',
                            value: this.$moment(
                                data.customer_data.dateofexpiry,
                                'D-M-Y'
                            ).isValid()
                                ? this.$moment(
                                      data.customer_data.dateofexpiry,
                                      'D-M-Y'
                                  ).format('YYYY-MM-DD')
                                : '',
                        })

                        let fullName = _.split(data.customer_data.name, ' ')

                        let firstName = fullName.shift()
                        let lastName = fullName.pop()
                        let middleName = fullName.join(' ')

                        this.$store.commit('updateField', {
                            key: 'basicInfo.firstName',
                            value: firstName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.middleName',
                            value: middleName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.lastName',
                            value: lastName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.dateOfBirth',
                            value: this.$moment(
                                data.customer_data.dob,
                                'D-M-Y'
                            ).isValid()
                                ? this.$moment(
                                      data.customer_data.dob,
                                      'D-M-Y'
                                  ).format('YYYY-MM-DD')
                                : '',
                        })
                    }
                } catch (error) {
                    // console.log(error)
                }
                this.$store.commit('setLoading', false)
            }
        }, // End of user() method
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.$emit('openPmdaModal')
        this.$store.dispatch('trackEvent', {
            event: 'JS | Register Upload Documents',
        })

        if (
            this.fieldW9Form.keyBackEnd === 'w9Form' &&
            this.fieldW8Form.keyBackEnd === 'w8Form'
        ) {
            let idResidentUS =
                this.$store.state.registration.form.contactInfo.residentUS
            // console.log("residentUS ",idResidentUS)
            this.fieldW9Form.isRequired = registrationRequiresW9(
                this.$store.state.registration.form
            )
            if (idResidentUS && idResidentUS.toLowerCase().trim() == 'yes') {
                this.fieldW8Form.isRequired = true
            } else {
                this.fieldW8Form.isRequired = false
            }
        }

        if (this.fieldUtility.keyBackEnd === 'utility') {
            let isd = this.$store.state.registration.form.contactInfo.isdCode
            let pmdaOption =
                this.$store.state.registration.form.pmd.recievePmdaOption
            let id = this.$store.state.registration.form.identityInfo.type
            // console.log("pmdaOption", pmdaOption)
            if (isd && isd === '+92' && id && id == 'id') {
                if (pmdaOption === 'Company') {
                    this.showName = 'c-visible'
                    this.fieldPmdaCompany.isRequired = true
                } else if (pmdaOption === 'Relative') {
                    this.showName = 'r-visible'
                    this.fieldPmdaRelative.isRequired = true
                }
            } else {
                this.fieldUtility.isRequired = true
                this.fieldUtility.show = true
            }
        }

        if (this.fieldZakatAffidavit.keyBackEnd == 'zakatAffidavit') {
            let religion =
                this.$store.state.registration.form.basicInfo.religion
            let zakatOption =
                this.$store.state.registration.form.basicInfo.zakat
            // console.log("zakat ", zakatOption)
            if (
                religion &&
                religion == 'Muslim' &&
                zakatOption &&
                zakatOption == 'No'
            ) {
                this.fieldZakatAffidavit.show = true
                this.fieldZakatAffidavit.isRequired = true
            } else {
                this.fieldZakatAffidavit.show = false
                this.fieldZakatAffidavit.isRequired = false
            }
        }
    }, // End of Component > mounted

    created() {
        // Watching pmd option
        let isd = this.$store.state.registration.form.contactInfo.isdCode

        if (isd && isd === '+92') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.pmd
                        .recievePmdaOption
                },
                (newValue) => {
                    if (newValue == 'Company') {
                        this.showName = 'c-visible'
                        this.fieldPmdaCompany.isRequired = true
                    } else if (newValue == 'Relative') {
                        this.showName = 'r-visible'
                        this.fieldPmdaRelative.isRequired = true
                    }
                }
            )
        } else {
            this.fieldUtility.isRequired = true
            this.fieldUtility.show = true
        }
        // End
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */

        checkIsInvalid() {
            let newValue = this.$store.state.registration.form.rcForms
            let invalidFormNames = []
            let invalidForm = false
            for (let key in newValue) {
                if (newValue.hasOwnProperty(key)) {
                    // console.log(key + ' -> ' + newValue[key]['valid'])
                    if (newValue[key]['valid'] == false) {
                        invalidForm = true
                        invalidFormNames.push(newValue[key]['name'])
                    }
                }
            }
            return invalidForm
        },

        routing() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    // name: 'public-registration-record-video',
                    name: 'public-registration-preview',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                // this.$router.push('/register-customer/record-video')
                this.$router.push('/register-customer/preview')
                // this.$router.push('/register-customer/risk-product')
            }
        },
        async onSubmit() {
            //this.$router.push('/register-customer/KYC')
            // validate the form fields
            const result = await this.$validator.validateAll()
            // Check if validation fails
            if (result) {
                this.$store.commit('updateField', {
                    key: 'rcForms.form7.valid',
                    value: true,
                })

                let newValue = this.$store.state.registration.form.rcForms

                let invalidForm = false
                let invalidFormNames = []
                for (let key in newValue) {
                    if (newValue.hasOwnProperty(key)) {
                        // console.log(key + ' -> ' + newValue[key]['valid'])
                        if (newValue[key]['valid'] == false) {
                            invalidForm = true
                            invalidFormNames.push(newValue[key]['name'])
                        }
                    }
                }

                if (!invalidForm) {
                    if (this.$route.meta.publicRegistration === true) {
                        this.$router.push({
                            // name: 'public-registration-record-video',
                            name: 'public-registration-preview',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                            },
                        })
                    } else {
                        // this.$router.push('/register-customer/record-video')
                        this.$router.push('/register-customer/preview')
                        // this.$router.push('/register-customer/risk-product')
                    }
                } else {
                    let msg = 'Kindly fill ' + invalidFormNames[0] + ' Form'

                    this.$store.commit('setError', msg)
                }
            } else {
                this.$store.commit('updateField', {
                    key: 'rcForms.form7.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }
        },

        onBack() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-risk-product',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/register-customer/risk-product')
            }
        },
    }, // End of onSubmit() method
} // End of export default
</script>
